import ApiService from "./config";

/*login*/
export const registerGoogle
  = (body) => {
    return ApiService.post("/users/googleLogin", body);
  };


export const registerUser = (body) => {
  return ApiService.post("/users/registerUser", body);
};

export const loginUser = (body) => {
  return ApiService.post("/users/loginUser", body);
};

export const resetPassword = (body, token) => {
  return ApiService.post(`/users/resetPassword?token=${token}`, body);
};

export const generateOtp = (body) => {
  return ApiService.post("/users/generateOtp", body);
};

export const verifyOtp = (body) => {
  return ApiService.post("/users/verifyOtp", body);
};

export const forgotPassword = (body) => {
  return ApiService.post("/users/forgotPassword", body);
};

/*razorpay*/
export const createRazorpayOrder = (body) => {
  return ApiService.post("/payments/createRazorpayOrder", body);
};

/*razorpay Contacts*/
export const createRazorpayOrderContacts = (body) => {
  return ApiService.post("/payments/createSalesRazorpayOrder", body);
};

export const handlePaymentSuccess = (body) => {
  return ApiService.post("/payments/handlePaymentSuccess", body);
};
export const handlePaymentSuccesscontacts = (body) => {
  return ApiService.post("/payments/handleSalesPaymentSuccess", body);
};

// company details
export const create_companies = (cin, params) => {
  const queryParams = new URLSearchParams(params).toString();
  return ApiService.get(`/tabData/${cin}?${queryParams}`);
};

/*reference doucument */
export const referenceDocument = (page, limit, documentCategory, cin) => {
  return ApiService.get(
    `/referenceDocument?cin=${cin}&documentCategory=${documentCategory}&page=${page}&limit=${limit}`
  );
};

/*open charges*/
export const getChargeDetails = (cin) => {
  return ApiService.get(`chargeDetail?CIN=${cin}`);
};

/*index of charges*/
export const getIndexopenCharges = (cin, page = 1, limit = 10) => {
  return ApiService.get(`chargeDetail/openCharges?CIN=${cin}&page=${page}&limit=${limit}`);
};

/*finacial data*/
export const getfinacialdata = (cin) => {
  return ApiService.get(`/companies/${cin}/financial-data`);
};

export const getLLPfinacialdata = (cin) => {
  return ApiService.get(`/companies/${cin}/llpFinancialData`);
};




/*structure*/
export const getstructuredata = (cin) => {
  return ApiService.get(`/companies/${cin}/structure`);
};

export const getllpstructuredata = (cin) => {
  return ApiService.get(`/companies/${cin}/llpStructure`);
};


/*highlights*/

export const gethighlightsdata = (cin) => {
  return ApiService.get(`/companies/${cin}/highlights`);
};

/*compliance check*/

export const getcompliancecheck = (cin) => {
  return ApiService.get(`tabdata/compliance/${cin}`);
};

export const getAboutTheCompany = (cin) => {
  return ApiService.get(`/tabdata/aboutTheCompany/${cin}`);
};

export const getDirector = (cin) => {
  return ApiService.get(`/tabdata/director/${cin}`);
};

/*Search api home*/
export const searchByName = (name) => {
  return ApiService.get(`companies/search?name=${name}`);
};

export const searchCompanies = (query) => {
  return ApiService.get(`companies/search`, { params: { ...query } });
};
export const searchCompaniesPublic = (query) => {
  return ApiService.get(`companies/search`, { params: { ...query } });
};

// export const searchCompanies = (url) => {
//   return ApiService.get(url);
// };


export const searchCompaniesById = (cin, token) => {
  return ApiService.get(`companies/${cin}`, token);
};
export const checkIfCompanyPaid = (body) => {
  return ApiService.post(`companies/buyContactCompanyData`, body);
};

/*my kohere*/
export const getMykohere = () => {
  return ApiService.get("/users/getUserByTokenId");
};

export const buyCompanyData = (token, requestBody) => {
  return ApiService.post("/companies/buyCompanyData", requestBody);
};

export const getPurchasedCompaniesByUser = (token) => {
  return ApiService.get("/purchases/getPurchasedCompaniesByUser");
};

/*my kohere credits details*/

export const creditPricing = () => {
  return ApiService.get("/creditPricing");
};
export const ContactcreditPricing = () => {
  return ApiService.get("/creditPricing/salesContactPrices");
};

/*resources*/
export const getAllresources = () => {
  return ApiService.get("/resources");
};

export const getResourceById = (id) => {
  return ApiService.get(`/resources/${id}`);
};

export const getcreditPurchaseHistory = (type) => {
  return ApiService.get(`/creditPurchaseHistory?type=${type}`);
};

// export const getbusinessForSale = () => {
//   return ApiService.get(`/businessForSale`);
// };

/*Banners*/
export const getAllbanners = () => {
  return ApiService.get("/banners");
};

/*Services*/
export const getAllServices = () => {
  return ApiService.get("/services");
};

export const getSubCategoryServices = () => {
  return ApiService.get("/services/byCategory");
};

export const getservicedropdown = () => {
  return ApiService.get("/serviceCategory/categoriesAndSubcategories");
};

export const getAllServiceSubCategoryId = (id) => {
  return ApiService.get(`/services/bySubCategory/${id}`);
};

export const getAllServiceByCategoryIdAndSubCategory = (
  CategoryId,
  subcategoryId
) => {
  return ApiService.get(
    `services/byCategoryId/${CategoryId}/subcategoryId/${subcategoryId}`
  );
};

export const getServicesById = (id) => {
  return ApiService.get(`/services/${id}`);
};

export const getAllpartners = () => {
  return ApiService.get("/partners");
};

export const updateUserdetails = (updateData) => {
  return ApiService.put("/users/updateUser", updateData);
};

export const history = (data) => {
  return ApiService.post("/history", data);
};

export const getUserHistory = () => {
  return ApiService.get("/history");
};

export const getUserblogs = () => {
  return ApiService.get("/blogs");
};

export const blogsreplay = (requestData) => {
  return ApiService.post("/blogReplies", requestData);
};

export const getblogCategories = () => {
  return ApiService.get("/blogCategories");
};

export const getUserblogsbyid = (id) => {
  return ApiService.get(`/blogs/${id}`);
};
export const getUserblogsbyslug = (id) => {
  return ApiService.get(`blogs/getBlog/${id}`);
};

export const gettestimonial = () => {
  return ApiService.get(`/testimonial`);
};

// export const gethomefaqs = () => {
//   return ApiService.get(`/faqs`);
// };

export const getHomeFaqs = (category = "") => {
  const url = category
    ? `/faqs?category=${encodeURIComponent(category)}`
    : "/faqs";

  return ApiService.get(url);
};



export const getContactBusinesslabels = () => {
  return ApiService.get(`/interestedInContactInquiry`);
};

export const contactInquiry = (body) => {
  return ApiService.post(`/contactInquiry`, body);
};

export const BusinessesforSalecardscreate = (body) => {
  return ApiService.post(`/businessForSale`, body);
};

export const BusinessesforSalecardbyId = (CIN) => {
  return ApiService.get(`/businessForSale/${CIN}`);
};

export const ComplianceCalendar = (startMonth, endMonth) => {
  return ApiService.get(
    `/complianceCalendar/range?startMonth=${startMonth}&endMonth=${endMonth}`
  );
};

/*contact */
export const contact = (body) => {
  return ApiService.post(`/contact`, body);
};

/*Teams*/
export const createTeams = (body) => {
  return ApiService.post(`/teams`, body);
};

export const getTeamsByUserId = () => {
  return ApiService.get(`/teams/byUserId`);
};

export const getTeamsById = (teamId) => {
  return ApiService.get(`/teams/${teamId}`);
};

export const updateTeamName = (teamId, body) => {
  return ApiService.put(`/teams/${teamId}`, body);
};

export const deleteTeam = (teamId) => {
  return ApiService.delete(`/teams/${teamId}`);
};

export const Teaminvite = (body) => {
  return ApiService.post(`/teamMember/invite`, body);
};

export const getTeamsMembersByTeamId = (teamId) => {
  return ApiService.get(`/teamMember/${teamId}`);
};

export const acceptInvitation = (requestBody) => {
  return ApiService.post(`/teamMember`, requestBody);
};

/*business for sale  filter*/

export const searchfilter = (requestBody) => {
  return ApiService.post(`/companies/comprehensiveSearch`, requestBody);
};

export const businessForSalefilterapi = (requestBody) => {
  return ApiService.post(`/businessForSale/getBusinessForSale`, requestBody);
};

export const businessForSalefilter = (requestBody, page, limit) => {
  return ApiService.post(
    `/businessForSale/getBusinessForSale?page=${page}&limit=${limit}`,
    requestBody
  );
};

export const filterlocations = () => {
  return ApiService.get(`/businessForSale/locations`);
};

export const getCompanyMiscData = (cin, din) => {
  return ApiService.get(`/companies/getCompanyMiscData?cin=${cin}&din=${din}`);
};

export const createContactInquiry = (body) => {
  return ApiService.post(`/contactInquiry`, body);
};

{
  /*drop down*/
}
export const getInterestedInContactInquiryById = (id) => {
  return ApiService.get(`/interestedInContactInquiry/${id}`);
};

export const getAllInterestedInContactInquiry = () => {
  return ApiService.get(`/interestedInContactInquiry`);
};

export const getCompanynotoken = (cin) => {
  return ApiService.get(`/companies/noToken/${cin}`);
};

export const getdownloadrequestdocuments = (cin) => {
  return ApiService.get(`/referenceDocsArchives/CIN/${cin}`);
};

export const downloadrequestdocuments = (body) => {
  return ApiService.post(`/referenceDocsArchives/archiveRequest`, body);
};

export const getExpiredPurchasedCompaniesByUser = () => {
  return ApiService.get(`/purchases/getExpiredPurchasedCompaniesByUser`);
};
/*search apis get*/
export const getDistinctClassifications = () => {
  return ApiService.get(`/companies/classifications`);
};

export const getDistinctcorporatestatus = () => {
  return ApiService.get(`/companies/companyStatus`);
};

export const getDistinctlistingStatus = () => {
  return ApiService.get(`/companies/companyClass`);
};
export const getDistinctCompanyIndustry = () => {
  return ApiService.get(`/companies/industry`);
};
export const getDistinctCompanySegment = () => {
  return ApiService.get(`/companies/segment`);
};

export const constRefresh = (body) => {
  return ApiService.post(`/companyRefreshRequest`, body);
};

export const getCompanyRefreshRequestStatus = (cin) => {
  return ApiService.get(`companyRefreshRequest/refreshStatus/${cin}`);
};

export const ServiceReplycreateServiceReply = (body) => {
  return ApiService.post(`/serviceReply`, body);
};

export const getfranchiseForm = (body) => {
  return ApiService.post(`/franchiseForm`, body);
};

export const getAllResourceCategories = () => {
  return ApiService.get(`/resourceCategories`);
};

export const getResourceByCategoryId = (CategoryId) => {
  return ApiService.get(`/resources/byCategory/${CategoryId}`);
};

export const getAllCategoryWithServices = () => {
  return ApiService.get(`/services/category`);

};

export const getDistinctCity = () => {
  return ApiService.get(`/businessForSale/city`);
};

export const getDistinctState = () => {
  return ApiService.get(`/businessForSale/state`);
};

export const gethomeserviceCategory = () => {
  return ApiService.get(`/serviceCategory`);
};

export const gethomecontactform = (body) => {
  return ApiService.post(`/contactUs/addContactUs`, body);
};

export const getfootercontact = () => {
  return ApiService.get(`/contactUs/getAllContacts`);
};


export const getdashboardServices = (body) => {
  return ApiService.get(`/services/dashboardServices`, body);
};

export const getcompanyReport = (cin, format) => {
  return ApiService.get(`/companyReport/generateReport/${cin}?format=${format}`, {
    responseType: 'blob',
  });
};

export const getALlExpertTeam = () => {
  return ApiService.get(`/expertTeams/getExpertTeam`);
};

// services/APIrequests.js
export const getwebsiteconfigs = (name) => {
  return ApiService.get(`/websiteConfigs/getAllWebSite/${encodeURIComponent(name)}`);
};

export const newletters = (body) => {
  return ApiService.post(`/blogs/addLetter`, body);
};


/* Protean API's */

/*Company Master */
export const companyMaster = (body) => {
  return ApiService.post(`/proteanApi/companyMaster`, body);
};

/* MCA Signature */
export const mcaSignature = (body) => {
  return ApiService.post(`/proteanApi/mcaSignatories`, body);
};

/* ROC Director Search */
export const rocDirectorSearch = (body) => {
  return ApiService.post(`/proteanApi/rocDirectorSearch`, body);
};

/* Look Up Company */
export const lookUpCompany = (body) => {
  return ApiService.post(`/proteanApi/cinLookup`, body);
};

/* MCA Search Lite */
export const mcaSearchLite = (body) => {
  return ApiService.post(`/proteanApi/compsearch-lite`, body);
};